import i18n from 'i18next';
import { debounce } from 'lodash-es';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import axios from 'axios';
import { LANGS, EN_US } from 'consts';
import localStorageService from 'services/localStorage';

export const browserLanguage = (() => {
  const language = window.navigator.userLanguage ?? window.navigator.language;
  return language;
})();

const getServerLangClientMapping = langs => {
  return Object.keys(langs).reduce((acc, langKey) => {
    const { serverLang } = langs[langKey];
    if (!serverLang) return acc;

    return {
      ...acc,
      [serverLang]: langKey
    };
  }, {});
};

const languagesMapping = getServerLangClientMapping(LANGS);
export const serverLang2Client = serverLang => languagesMapping[serverLang];

const getSupportedLang = lang => {
  if (LANGS[lang]) {
    return lang;
  }

  if (LANGS[serverLang2Client(lang)]) {
    return serverLang2Client(lang);
  }

  return EN_US;
};

export const changeLanguage = debounce(
  lang => i18n.changeLanguage(getSupportedLang(lang)),
  100
);
export const asyncChangeLanguage = async lang =>
  i18n.changeLanguage(getSupportedLang(lang));

export const initTranslations = ({ translations_url_v2: translationsUrl }, pageToken) => {
  if (!i18n.isInitialized) {
    i18n
      .use(HttpApi)
      .use(initReactI18next)
      .init({
        lng: getSupportedLang(
          localStorageService.getItem(`${pageToken}_lang`) || browserLanguage
        ),
        fallbackLng: 'en-US',
        ns: ['common', 'fields'],
        load: 'currentOnly',
        defaultNS: 'common',
        fallbackNS: 'common',
        interpolation: { escapeValue: false },
        backend: {
          loadPath: lngs => {
            const lng = lngs[0];

            if (['en-US', 'en'].includes(lng)) {
              return '/translations/en-US/{{ns}}.json';
            }

            return `${translationsUrl}/{{lng}}/{{ns}}.json`;
          },
          request: async (options, url, payload, callback) => {
            if (url) {
              try {
                axios.get(url, { timeout: 2000 }).then(res => callback(null, res));
              } catch (err) {
                callback(err, null);
              }
            }
          }
        },
        react: {
          useSuspense: false,
          transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'b']
        }
      });
  }
};

export default i18n;
